import VPageIntegralUpdateRecord from './index.vue';

export default {
  install: (Vue) => Vue.component('VPageIntegralUpdateRecord', VPageIntegralUpdateRecord),
};
